import { useState, FC } from "react";
import styles from "./users-list-view.module.css";
import { useTranslation } from "@coworker/locales";
import { SimpleToast } from "../../../../simple/SimpleToast/SimpleToast";
import { FixaListView } from "../../../../wrappers/FixaListView/FixaListView";
import { FixaListViewItem } from "../../../../wrappers/FixaListView/FixaListViewItem";
import { User } from "../../../../types/user";

interface UsersListViewProps {
  users: User[] | undefined;
  id: string;
}
export const UsersListView: FC<UsersListViewProps> = ({ users, id }) => {
  const [toastVisible, setToastVisible] = useState(false);
  const [copiedEmail, setCopiedEmail] = useState("");
  const { t } = useTranslation();
  const copyUserEmail = (email: string) => {
    navigator.clipboard.writeText(email);
    setCopiedEmail(email);
    setToastVisible(true);
  };
  return (
    <div>
      <SimpleToast
        text={`${t("copiedString")} ${copiedEmail}!`}
        isOpen={toastVisible}
        onCloseRequest={() => {
          setToastVisible(false);
        }}
        ariaLabelCloseBtn={t("dismissNotificationString")}
        ariaLabel={t("copyUserEmailString")}
      />
      <FixaListView
        key={id}
        id={id}
        className={styles["users-list-view"] ?? ""}
      >
        {users?.map((user: User, index: number) => {
          return (
            <FixaListViewItem
              className={styles["users-list-view-item"] || ""}
              name={user?.uid ?? `user_${index}`}
              control={"navigational"}
              controlIcon={"copy"}
              onClick={() => copyUserEmail(user?.email)}
              title={user?.fullName}
              description={user?.email}
            ></FixaListViewItem>
          );
        })}
      </FixaListView>
    </div>
  );
};
